import type { PropsWithChildren } from 'react';

import { cn } from '~/lib/cn';
import { ContentBox as ContentBoxComponent } from '~/modules/settings/components/ContentBox';

type Props = PropsWithChildren<{
  className?: string;
}>;

export function ContentBox({ children, className }: Props) {
  return (
    <ContentBoxComponent
      className={cn('px-md pb-lg pt-md bg-level-04', className)}
    >
      {children}
    </ContentBoxComponent>
  );
}

ContentBox.displayName = 'ContentBox';
